import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./helpers/ScrollToTop";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Submitted from "./pages/Submitted";
import NotFound from "./pages/NotFound";
import LongDistanceMoving from "./pages/services/LongDistanceMoving";
import LocalMoving from "./pages/services/LocalMoving";
import SeniorMoving from "./pages/services/SeniorMoving";
import LargeHomeMoving from "./pages/services/LargeHomeMoving";
import WhiteGloveMoving from "./pages/services/WhiteGloveMoving";
import Storage from "./pages/services/Storage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Faq from "./pages/Faq";
import ReactGA from "react-ga4";
import Header from './components/Header/Header'

ReactGA.initialize("G-Z0GT624R0X");

function App() {
  return (
    <Router>
      <ScrollToTop>
        <Header /> 
        <Routes>
          <Route
            exact
            path={`${process.env.PUBLIC_URL + "/"}`}
            element={<Home />}
            key="Home"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/home"}`}
            element={<Home />}
            key="Home"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/about"}`}
            element={<About />}
            key="About"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/gallery"}`}
            element={<Gallery />}
            key="Gallery"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/contact"}`}
            element={<Contact />}
            key="Contact"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/long-distance-moving"}`}
            element={<LongDistanceMoving />}
            key="LongDistanceMoving"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/local-moving"}`}
            element={<LocalMoving />}
            key="LocalMoving"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/senior-moving"}`}
            element={<SeniorMoving />}
            key="SeniorMoving"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/large-home-moving"}`}
            element={<LargeHomeMoving />}
            key="LargeHomeMoving"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/white-glove-moving"}`}
            element={<WhiteGloveMoving />}
            key="WhiteGloveMoving"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/storage"}`}
            element={<Storage />}
            key="Storage"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/faq"}`}
            element={<Faq />}
            key="Faq"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/privacy-policy"}`}
            element={<PrivacyPolicy />}
            key="PrivacyPolicy"
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/submitted"}`}
            element={<Submitted />}
            key="Submit"
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ScrollToTop>
    </Router>
  );
}

export default App;
